<template>
	<b-alert v-if="disabled" class="p-2 d-flex" show variant="warning">
		<h5 class="mb-0">
			Es necesario <router-link to="/brain/encaste-settings/temporadas">agregar</router-link> una nueva Temporada.
		</h5>
	</b-alert>
</template>

<script>
export default {
	name: "AlertSeasonEncaste",
	computed: {
		disabled() {
			return this.$store.state.utilities.disabled;
		},
	},
	mounted() {
		// console.log("store", this.disabled);
	},
};
</script>
